module.exports = "<p>\r\n  cm works!\r\n</p>\r\n"